module.exports = __webpack_public_path__ + "static/psych-b5444cc238d6d7ed40da2076c87dc152.png";